import { Platform } from 'react-native';

import { useLiquidGlass } from '@/components/ui/glass';

/**
 * Whether bars float on this device: transparent over the top of the screen, which is every
 * bar wherever iOS draws Liquid Glass. A floating bar takes no room in the screen's layout,
 * so anything measured from the top of the screen, such as a keyboard offset, must not also
 * add the bar's height.
 */
export function useIsHeaderFloating(): boolean {
  const hasGlass = useLiquidGlass();

  return Platform.OS === 'ios' && hasGlass;
}
